import { render, staticRenderFns } from "./CourseRegistrationsTableItem.vue?vue&type=template&id=031d71a5&"
import script from "./CourseRegistrationsTableItem.vue?vue&type=script&lang=ts&"
export * from "./CourseRegistrationsTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports